import { render, staticRenderFns } from "./myStudy.vue?vue&type=template&id=dc42b38a&scoped=true"
import script from "./myStudy.vue?vue&type=script&lang=js"
export * from "./myStudy.vue?vue&type=script&lang=js"
import style0 from "./myStudy.vue?vue&type=style&index=0&id=dc42b38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc42b38a",
  null
  
)

export default component.exports